// 單位介紹頁面
import React from "react";
export const Origin = () => {
  return (
    <div className="mb-16">
      <div className="flex items-center staticBanner bg-[#eac7a3] relative">
        <div className="staticBannerContent">
          <img
            src="/images/unitBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-1/4 max-h-full">
            <h2 className=" font-black text-primaryDark">我們的使命與價值</h2>
            <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              為全面推動中小學數位學習精進方案，協助學校提高數位教學與學習品質及成效，高雄市政府教育局成立數位學習推動辦公室。
            </p>
          </div>
        </div>
      </div>
      <div className="staticSection">
        <div className="sectionContent">
          <h3 className="sectionTitle text-Headline">緣起與背景</h3>
          <div className="md:flex gap-6 items-center text-base lg:text-2xl">
            <img
              src="/images/63186c0113a01.jpg"
              alt=""
              className="w-full md:w-2/5"
            />
            <p className="text-text mt-4 text-justify leading-normal">
              行政院111年起，推動中小學數位學習精進方案【班班有網路、生生用平板】，主要為加強學生數位科技應用能力，熟悉數位學習平臺、工具與資源使用，
              並運用數位學習平臺培養自主學習能力，期能縮减城鄉數位教育落差達公平教育的目標，並於疫情期間可支援經濟弱勢、多子家庭學生有學習載具可使用。
              教育部透過前瞻基礎建設計畫，強化校園網路佈建與建置智慧學習教室等設施作為基礎，乃盤整現有數位建設基礎下，規劃「數位内容充實」、
              「行動載具與網路提升」及「教育大數據分析」3項計畫,期透過本方案達成「教材更生動」、「書包更輕便」、「教學更多元」、「學習更有效」、
              「城鄉更均衡」5大目標。
            </p>
          </div>
          <div className="md:flex gap-6 items-center text-base lg:text-2xl">
            <p className="text-text mt-4 text-justify leading-normal mb-4">
            本市教育政策以「國際、跨域、共榮、永續」為目標，K-12學校教育規劃有系統、適性、多元、有效的教育策略，
            期盼能兼顧學子增能與未來之需求，讓學生自然將英語作為溝通與學習的工具，加上善用數位學習載具悠遊於無遠弗屆的資訊科技網路時代，
            強化其橫向移動的競爭力與跨領域的國際素養，培養高雄學子成為邁向國際的世界公民，實踐共好共榮、永續傳承的教育願景。
            因此，本市為集中有限的資源並整合產官學民量能，乃成立【雙語曁數位學習推動辦公室】來積極推動雙語和數位學習兩大重要教育政策，
            全面落實相關政策與計畫之有效推動，促進政策目標之達成並嘉惠本市莘莘學子。

            </p>
            <img src="/images/20221015.jpg" alt="" className="w-full md:w-2/5" />
          </div>
        </div>
      </div>
    </div>
  );
};
